import { render, staticRenderFns } from "./DashboardPeopleActions.vue?vue&type=template&id=75e94d36"
import script from "./DashboardPeopleActions.vue?vue&type=script&lang=ts"
export * from "./DashboardPeopleActions.vue?vue&type=script&lang=ts"
import style0 from "./DashboardPeopleActions.vue?vue&type=style&index=0&id=75e94d36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports